export default __webpack_public_path__ + "static/inter-latin-variable-wghtOnly-normal-b2ee717fe8acb65ab08ed0638a286ea1.woff2";